export const product = p => {
    return true
   }